export const menuButton = ():void => {
	const menuButton	= document.querySelector<HTMLElement>(".js-mobile-menu-button");
	const menu			= document.querySelector<HTMLElement>(".js-mobile-menu");

	if (menuButton === null || menu === null)	return;

	menuButton.addEventListener("click", () => menu.classList.toggle("open"));
};
